import { Lock, Mail, Save, User } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useAuth } from "../../contexts/AuthContext";
import { useState } from "react";

export const AccountSettings = ({
  email,
  setEmail,
  saving,
  handleSaveEmail,
}) => {
  const { changePassword } = useAuth();

  // New states
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [changingPassword, setChangingPassword] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    setChangingPassword(true);

    const res = await changePassword({
      currentPassword,
      newPassword,
      confirmPassword,
    });

    setChangingPassword(false);

    if (res.success) {
      alert("✅ Password changed successfully");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } else {
      alert("❌ " + res.message);
    }
  };

  return (
    <Card className="lg:col-span-2 border-0 shadow-lg rounded-2xl">
      <CardHeader className="bg-gradient-to-r from-igbanwo-mint to-teal-600 text-white rounded-t-2xl">
        <CardTitle className="flex items-center text-xl">
          <User className="w-5 h-5 mr-3" />
          Account settings
        </CardTitle>
        <CardDescription className="text-white">
          Update your email and password
        </CardDescription>
      </CardHeader>

      <CardContent className="!p-6">
        {/* Email */}
        <form className="space-y-6" onSubmit={handleSaveEmail}>
          <div className="space-y-4">
            <div className="flex items-center space-x-2 text-slate-700 mb-4">
              <Mail />
              <Label>Email</Label>
            </div>

            <div>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>
          <div className="pt-0">
            <Button type="submit" disabled={saving}>
              <Save className="w-4 h-4 mr-2" />
              {saving ? "Saving..." : "Save Email Changes"}
            </Button>
          </div>
        </form>

        {/* Seperator */}
        <div className="mt-7 w-100 h-1 border-t"></div>

        {/* Password */}
        <form className="space-y-6 mt-7" onSubmit={handlePasswordChange}>
          <div className="space-y-4">
            <div className="flex items-center space-x-2 text-slate-700 mb-4">
              <Lock />
              <Label>Password Security</Label>
            </div>

            <div className="grid md:grid-cols-1 gap-4">
              <div className="space-y-2">
                <Label>Current password</Label>
                <Input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>New Password</Label>
                  <Input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <Label>Confirm New Password</Label>
                  <Input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="pt-4">
            <Button type="submit" disabled={changingPassword}>
              <Save className="w-4 h-4 mr-2" />
              {changingPassword ? "Updating..." : "Save Password Changes"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
